import React, { FC } from 'react';
import { Flex, Typography } from '@creditas-ui/react';
import { IconHeadphonesCustomerSupport, IconQuestionCircle } from '@creditas-ui/icons';
import { GlobalIcons } from '@creditas-ui/global-icons';
import { ShapeIcons } from '@creditas-ui/shape-icons';
import { ModalHeader } from '@creditas-ui/modal';

import { HelpModalComponentProps, Contact } from './helpModal.types';
import { ContactCard, CustomFlex, CustomModalBody, CustomModalRoot } from './helpModal.styles';

const HelpModalComponent: FC<HelpModalComponentProps> = ({
  isOpen,
  closeModal,
  handleContactRedirect,
  contactList,
}: HelpModalComponentProps) => {
  return (
    <CustomModalRoot isOpen={isOpen} closeModal={closeModal} allowClose size="medium">
      <ModalHeader title="Soporte" />
      <CustomModalBody>
        <ShapeIcons Icon={IconQuestionCircle} size="x_small" />
        <Typography variant="headingSmLight" color="neutral.90" margin="32px 0 24px">
          ¿Necesitas ayuda con tu solicitud?
        </Typography>
        <Typography variant="bodyMdRegular" color="neutral.80">
          Resuelve tus dudas contactándonos
        </Typography>
        <CustomFlex margin="20px 0 49px">
          {contactList.map((contact: Contact) => (
            <ContactCard onClick={() => handleContactRedirect(contact.url)} key={contact.name}>
              <GlobalIcons Icon={contact.icon} size="medium" color={'#23a969' as any} />
              <Typography variant="bodyXsRegular" color="neutral.90">
                {contact.name}
              </Typography>
            </ContactCard>
          ))}
        </CustomFlex>
        <Flex>
          <GlobalIcons Icon={IconHeadphonesCustomerSupport} size="medium" color={'#23a969' as any} marginRight="16px" />
          <Typography variant="bodySmRegular" color="neutral.80">
            Nuestro horario de atención es de Lunes a Viernes de 9:00 a 18:00hrs
          </Typography>
        </Flex>
      </CustomModalBody>
    </CustomModalRoot>
  );
};

export default HelpModalComponent;
